module.exports = __webpack_public_path__ + "static/media/pop up mobile.997d15bf.png";